export const ROUTES = {
  ROOT: '/zones',
};
export const CREATE_NEW_ZONE_FORM = 'CREATE_NEW_ZONE';
export const UPDATE_ZONE_FORM = 'UPDATE_ZONE';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/planning/zoning/zones`;
export const REDUCER_NAME = 'zones';
export const ZONE_TYPES = [
  { value: 'DeliveryZone', description: ' Delivery Zone' },
  { value: 'PickupZone', description: 'Pickup Zone' },
  { value: 'BanZone', description: 'Ban Zone' },
];
